import { FAIconName, FireflyTertiaryButtonMenuItem } from '@equip.health/ui';

export const NO_NOTE_TEMPLATE_OPTION: FireflyTertiaryButtonMenuItem = {
  label: 'No template',
  node: 'No template',
};

export const NOTE_ATTACHMENT_MENU_OPTIONS: FireflyTertiaryButtonMenuItem[] = [
  {
    label: 'Link from documents',
    leftIcon: FAIconName.linkSimpleRegular,
    node: 'link',
  },
  {
    label: 'Upload from computer',
    leftIcon: FAIconName.fileArrowUpRegular,
    node: 'upload',
  },
];

export const NOTE_ATTACHMENT_MENU_NODE = {
  LINK: 'link',
  UPLOAD: 'upload',
};

export const NOTE_ATTACHMENT_SOURCES = {
  NOTE_TAB: 'noteTab',
  INQUIRY_PANEL: 'inquiryPanel',
};
